import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reportFill" }
const _hoisted_2 = { style: {"margin-top":"20px","text-align":"center"} }

import "@wangeditor/editor/dist/css/style.css"
import {ref, shallowRef} from "vue"
import {Editor} from "@wangeditor/editor-for-vue"
import {useRoute, useRouter} from 'vue-router'
import {getListData} from "@/service/main/system";
import {IEditorConfig} from "@wangeditor/core";



export default /*#__PURE__*/_defineComponent({
  __name: 'FAQDetail',
  props: {
  textHtml: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props

const confirmLoading = ref(false)
const editorRef = shallowRef();
const router = useRouter()
const route = useRoute()

const editorConfig: Partial<IEditorConfig> = {
  readOnly: true
}

const handleCreated = async (editor: any) => {
  if (route.query['opType'] == 'edit') {
    editorRef.value = editor; // 记录 editor 实例，重要！
    let faqInfo = await getListData('/main/faq/getFAQById', {
      id: route.query['faqId']
    })
    editor.setHtml(faqInfo.answer)
  }
}

const handleSubmitClick = () => {
  window.close()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Editor), {
      style: {"height":"740px","overflow-y":"hidden"},
      modelValue: props.textHtml,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.textHtml) = $event)),
      mode: 'default',
      defaultConfig: editorConfig,
      onOnCreated: handleCreated,
      readOnly: ""
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmitClick,
        loading: confirmLoading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}
}

})